import GavelIcon from '@material-ui/icons/Gavel';
import ContractList from './ContractList';
import ContractCreate from './ContractCreate';

export default {
    list: ContractList,
    create: ContractCreate,
    icon: GavelIcon,
};
